import { helpers } from "vuelidate/lib/validators";
export const urlValidator = helpers.regex('url',/^(https?:\/\/)(localhost|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|([a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))(:\d+)?(\/.*)?$/)
